import React from "react";
import {BrowserRouter} from "react-router-dom";
import Portfolio2026 from "./Portfolio2026";

function App() {
  return (
    <BrowserRouter>
      <Portfolio2026 />
    </BrowserRouter>
  );
}

export default App;
